import { useGetBlueprintDetails } from 'features/blueprints';
import { useParams } from 'react-router-dom';

export function BlueprintBreadcrumb() {
  const { id = '' } = useParams();
  const { blueprintDetails } = useGetBlueprintDetails({
    blueprintId: id,
    enabled: !!id,
  });

  return blueprintDetails?.name ?? id;
}
